import React from "react";
import { CustomerProvider } from "Contexts/customer-context";
import { UserProvider } from "Contexts/user-context";
import { NotificationBannersProvider } from "Contexts/notification-banners-context";

const GlobalContext: React.FC<React.PropsWithChildren<{}>> = ({ children }) => (
  <UserProvider>
    <CustomerProvider>
      <NotificationBannersProvider>{children}</NotificationBannersProvider>
    </CustomerProvider>
  </UserProvider>
);

export default GlobalContext;
